import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
            <span className="text-xs font-medium uppercase tracking-widest text-foreground-500">Community Reviews</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Real Shoppers. Real Savings.
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Thousands of fashion enthusiasts trust PandabuySpreadsheet for their monthly hauls. Here is what they are saying.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 ${
                idx === 5 ? 'opacity-50' : ''
              }`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-2">{t.headline}</h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-5">{t.text}</p>
              <div className="mt-4 pt-4 border-t border-background-200/60 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}